export default {
  "nav.spreadsheet": "Planilha",
  "nav.categories": "Categorias",
  "nav.guides": "Guias",
  "nav.faq": "FAQ",
  "nav.home": "Início",
  "nav.visitMain": "Visitar site principal",
  "nav.shoppingGuide": "Guia de compras",

  "hero.eyebrow": "O centro de recursos Basetao Spreadsheet",
  "hero.title": "Basetao Spreadsheet: produtos, vendedores e guias de compra",
  "hero.subtitle": "Explore categorias de produtos selecionadas, dicas de vendedores e guias de compra práticos — tudo organizado em um único lugar claro e fácil de navegar.",
  "hero.cta1": "Basetao Spreadsheet",
  "hero.cta2": "Comprar agora",
  "hero.note": "Todos os links de produtos abrem no site principal",

  "dropdown.label": "Explorar categorias",
  "dropdown.placeholder": "Selecione uma categoria de produtos",

  "categories.title": "Explore as categorias de produtos",
  "categories.subtitle": "Vá direto aos produtos que interessam. Cada categoria abre uma lista filtrada no site principal.",
  "categories.shoes": "Calçados",
  "categories.hoodies": "Moletons / Suéteres",
  "categories.tshirts": "Camisetas",
  "categories.jackets": "Jaquetas",
  "categories.pants": "Calças / Shorts",
  "categories.headwear": "Bonés e chapéus",
  "categories.sets": "Conjuntos",
  "categories.underwear": "Roupa íntima / Cuecas",
  "categories.jersey": "Camisas esportivas",
  "categories.accessories": "Acessórios",
  "categories.bags": "Bolsas",
  "categories.belts": "Cintos",
  "categories.perfumes": "Perfumes",
  "categories.other": "Outros itens",
  "categories.viewAll": "Ver tudo no site principal",

  "about.title": "O que é o Basetao Spreadsheet?",
  "about.p1": "O Basetao Spreadsheet reúne links de produtos, notas de vendedores e dicas de compra em um diretório fácil de navegar. Em vez de procurar um item por vez, você obtém um mapa claro de cada categoria — de calçados e moletons a bolsas e perfumes.",
  "about.p2": "Cada categoria abre uma visualização filtrada no site principal, para você ir de uma ideia ampla a um produto específico com um único clique. O resultado é uma forma mais rápida e tranquila de encontrar exatamente o que procura.",
  "about.p3": "Além do diretório, publicamos guias de compra práticos sobre vendedores, envio e controle de qualidade — todos escritos para ajudar você a comprar com mais confiança.",

  "guides.title": "Últimos guias da Basetao",
  "guides.subtitle": "Guias práticos e originais para explorar e comprar com confiança.",
  "guides.cardTitle": "Basetao Spreadsheet: guia completo (2026)",
  "guides.cardDesc": "Aprenda como a planilha funciona, explore as categorias, encontre vendedores confiáveis e entenda o envio e o controle de qualidade.",
  "guides.readArticle": "Ler o guia completo",
  "guides.updated": "Atualizado ago. 2026",
  "guides.badge": "Guia de compra",

  "faq.title": "Perguntas frequentes",
  "faq.subtitle": "Respostas rápidas sobre o Basetao Spreadsheet e como usá-lo.",
  "faq.q1": "O que é o Basetao Spreadsheet?",
  "faq.a1": "É um diretório selecionado de categorias de produtos, links e notas de compra que apontam para o site principal.",
  "faq.q2": "Como navego pelos produtos?",
  "faq.a2": "Use o menu suspenso de categorias ou os cartões abaixo. Cada opção abre uma lista de produtos filtrada no site principal.",
  "faq.q3": "É gratuito?",
  "faq.a3": "Sim — navegar pelo diretório e ler os guias é gratuito. As compras são feitas no site principal.",
  "faq.q4": "Como compro algo?",
  "faq.a4": "Escolha uma categoria, encontre seu produto no site principal e conclua o pagamento por lá.",

  "cta.title": "Pronto para explorar o Basetao Spreadsheet?",
  "cta.subtitle": "Navegue por todas as categorias em um só lugar e vá direto aos produtos que deseja.",
  "cta.primary": "Explorar Basetao Spreadsheet",
  "cta.secondary": "Visitar site principal",

  "footer.disclaimer": "Este site é um recurso informativo independente. Informações de produtos, vendedores, preços e disponibilidade podem mudar. Verifique sempre os detalhes importantes no site principal antes de comprar.",
  "footer.rights": "© 2026 Basetao Spreadsheet. Todos os direitos reservados.",
  "footer.resources": "Recursos",
  "footer.explore": "Explorar",
  "footer.home": "Início",
  "footer.guide": "Guia do Basetao Spreadsheet",
  "footer.categories": "Categorias de produtos",
  "footer.visitMain": "Visitar site principal",

  "article.notFound": "Artigo não encontrado",
  "article.notFoundDesc": "O artigo que você procura não existe ou foi movido.",
};